import View from './view';
export const SsmResult = View;
